// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c4120b6","453":"b56fb040","455":"c14c98bf","977":"cadee8ae"}[chunkId] + ".chunk.js";
};